// extracted by mini-css-extract-plugin
export var labelWrapper = "_e7-0";